import React from "react";
import SalesAndCostDashboard from "../mailingResponseSalesAndCostDashboard";
import Comments from "../comments";

const SalesAndCostBreakdown = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <SalesAndCostDashboard
        data={processedData?.sales_and_costs || {}}
        loading={loading}
      />
      <Comments tab_name="Sales and Cost Breakdown" />
    </div>
  );
};

export default SalesAndCostBreakdown;
